import Vue from 'vue'
import { initVue } from './utils/bridge/vue-instance'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/common'
import '@didi/soda-jsbridge'
// elvish
import { getElvish } from '@/utils/common/getElvish'
// i18n
import vueI18n from './i18n/locale'
import i18n from '@/i18n'
// 移动端适配
import '@/utils/common/rem'
import '@/assets/styles/mobile.styl'
import { is99, isDebug, isSim, inMerchantManager } from '@/utils/common/env'
import brand from '@/utils/common/brand'
import { init } from './init.js'
import {
  initCoverageConfig,
  mergeCoverageEnvConfig,
  mergeManagerCoverageEnvConfig,
} from './init-coverage.js'
import { refreshMerchantManagerContractorInfo } from '@/utils/bridge/fromMerchantManager'
import { isFromBDAPP } from '@/utils/bridge/fromBDAPP'
import Vconsole from 'vconsole'
import {
  initTriggerWebViewLifecycleEvent,
  initTriggerContractorInfoUpdatedEvent,
  triggerContractorInfoUpdatedEvent,
} from '@/common/bridge-core/index.js'
import DDBridge from '@/common/bridge/DDBridge'
import './common/bridge-core/flutter-bridge.js'

// 挑战应答
import { initSecdd } from '@didi/dclg'
Vue.use(DDBridge)

// 初始化端上页面生命周期通知函数
initTriggerWebViewLifecycleEvent()
// 管理端app：初始化主体切换监听
if (inMerchantManager) {
  initTriggerContractorInfoUpdatedEvent()
}
// 白屏监控函数
function whiteScreenMonitorChange() {
  if (window.$mounted) {
    window.$mounted()
  }
}

if (isDebug || isSim) {
  // eslint-disable-next-line no-new
  new Vconsole()
}

try {
  initSecdd &&
    initSecdd({
      domainList: [
        'b.didi-food.com/order/border/locatorVerify',
        'b.didi-food.com/order/border/locatorOrderComplete',
        'pre-b.didi-food.com/order/border/locatorVerify',
        'pre-b.didi-food.com/order/border/locatorOrderComplete',
        'b.99app.com/order/border/locatorVerify',
        'b.99app.com/order/border/locatorOrderComplete',
        'pre-b.99app.com/order/border/locatorVerify',
        'pre-b.99app.com/order/border/locatorOrderComplete',
      ],
    })
} catch (error) {
  console.warn('挑战应答初始化失败:', error)
}

const initConfig = () => {
  if (is99) {
    import('@/assets/theme/theme-99.css')
  }
  const $favicon = document.querySelector('link[rel="icon"]')
  $favicon.href = brand[is99 ? '99' : 'didi'].ico
  document.title = brand[is99 ? '99' : 'didi'].title
}
try {
  initConfig()
} catch (error) {
  console.warn('配置初始化失败:', error)
}

Vue.use(vueI18n)
Vue.use(i18n.plugin)

Vue.config.productionTip = false

initCoverageConfig()

init()
  .then(async () => {
    if (inMerchantManager) {
      mergeManagerCoverageEnvConfig()
    } else {
      mergeCoverageEnvConfig()
    }

    try {
      await getElvish()
      console.log('Elvish 初始化成功')
    } catch (error) {
      console.warn('Elvish 初始化失败，应用将继续运行:', error)
    }

    initVue({
      el: '#app',
      i18n: vueI18n,
      store,
      router,
      render: h => h(App), // 使用render函数避免template编译问题
    })

    whiteScreenMonitorChange()

    // TODO: [BDAPP] 判断如果在BDAPP中推出时隐藏titleBar
    if (isFromBDAPP()) {
      window.onbeforeunload = function () {
        if (window.Soda && window.Soda.toggleTitleBar) {
          window.Soda.toggleTitleBar(2)
        }
      }
    }

    // 管理端app：注册主体切换监听，端上切换主体后会通过 triggerContractorInfoUpdated 回调通知H5
    if (inMerchantManager) {
      triggerContractorInfoUpdatedEvent.register(() => {
        refreshMerchantManagerContractorInfo()
          .then(async () => {
            mergeManagerCoverageEnvConfig()
            // 主体切换后 countryCode 可能变化，需要重新初始化 Elvish 获取新的 cityId
            try {
              await getElvish()
              console.log('[MerchantManager] Elvish re-initialized after contractor switch')
            } catch (e) {
              console.warn('[MerchantManager] Elvish re-init failed:', e)
            }
          })
          .catch(e => {
            console.log(e)
          })
      })
    }
  })
  .catch(error => {
    console.error('应用初始化失败:', error)
    // 降级处理，直接启动应用
    initVue({
      el: '#app',
      i18n: vueI18n,
      store,
      router,
      render: h => h(App),
    })
  })
